import { menuApi } from "../../api";
import { ConfigureMenuRequest, CreateMenuRequest } from '../../types/menu/MenuConfiguration';

const MenuService = {
  /**
   * 🔹 Obtener todos los menús de un módulo (detalle completo)
   */
  getMenusByModule: async (moduleId: number) => {
    const response = await menuApi.fetchCustom(`/module/${moduleId}`);
    return response.data;
  },

  getMenuTree: async (moduleId: number) => {
    const response = await menuApi.fetchCustom(`/module/${moduleId}/tree`);
    return response.data;
  },

  searchMenus: async (moduleId: number, query: string) => {
    const response = await menuApi.fetchCustom(
      `/module/${moduleId}/search?query=${encodeURIComponent(query)}`
    );
    return response.data;
  },

  createMenu: async (payload: CreateMenuRequest) => {
    const response = await menuApi.add(payload);
    return response.data;
  },

  configureMenu: async (payload: ConfigureMenuRequest) => {
    const response = await menuApi.modifyCustom('/configuration', payload);
    return response.data;
  },

  deleteMenu: async (menuId: number) => {
    const response = await menuApi.remove(menuId);
    return response.data;
  },

  /**
   * 🔹 Obtener el detalle completo de un menú específico
   */
  getMenuDetail: async (menuId: number) => {
    const response = await menuApi.fetchCustom(`/${menuId}/detail`);
    return response.data;
  },

  /**
   * 🔹 Cambiar el nombre de un menú
   */
  updateMenuName: async (payload: object) => {
    const response = await menuApi.modifyCustom("/name", payload);
    return response.data;
  },

  /**
   * 🔹 Cambiar la ruta de un menú
   */
  updateMenuRoute: async (payload: object) => {
    const response = await menuApi.modifyCustom("/route", payload);
    return response.data;
  },

  /**
   * 🔹 Cambiar el orden de un menú
   */
  updateMenuOrder: async (payload: object) => {
    const response = await menuApi.modifyCustom("/order", payload);
    return response.data;
  },

  /**
   * 🔹 Cambiar los roles asociados a un menú
   */
  updateMenuRoles: async (payload: object) => {
    const response = await menuApi.modifyCustom("/roles", payload);
    return response.data;
  },
};

export default MenuService;
